import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-view-cma-slide',
  templateUrl: './view-cma-slide.component.html',
  styleUrls: ['./view-cma-slide.component.scss'],
})
export class ViewCmaSlideComponent implements OnInit {
  components = ['property-details', 'compare', 'valuation', 'cma-trends', 'more'];
  @Output() closeSlider: EventEmitter<void> = new EventEmitter<void>();
  currentIndex = 0;
  showSlider = false;

  constructor() { }

  ngOnInit(): void { }

  openSlider() {
    this.showSlider = true;
    this.currentIndex = 0;
  }
  nextSlide() {
    this.currentIndex = (this.currentIndex + 1) % this.components.length;
  }

  prevSlide() {
    this.currentIndex = (this.currentIndex - 1 + this.components.length) % this.components.length;
  }

  close() {
    this.closeSlider.emit(); // Emit event to parent
  }
}
